<template>
  <div class="history">
    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>
          Filters
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <attempt-filter :query.sync="query" :filters.sync="filters" flags/>
      </v-card-text>
    </v-card>
    <br>
    <v-card>
      <v-toolbar class="results-toolbar">
        <v-toolbar-title>
          Results
        </v-toolbar-title>
        <v-spacer />
        <v-flex shrink>
        <results-mutate :query="query" :results.sync="results"/>
        </v-flex>
        <v-flex shrink>
          <v-select
            :items="displays"
            v-model="display"
            label="Display Type"
          />
        </v-flex>
      </v-toolbar>
      <v-progress-linear
        v-if="slowPercent < 1"
        :value="slowPercent * 100"
        style="margin: 0;"
      />
      <component :is="display" :results="results" :filters="filters"/>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable object-curly-newline */
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import attemptFilter from './partials/attempt-filter.vue';
import resultsMutate from './partials/results/mutate.vue';
import resultsGraph from './partials/results/graph.vue';
import resultsTable from './partials/results/table.vue';

const year = (new Date()).getFullYear();
const startyear = new Date(`${year}-01-01`);
const midyear = new Date(`${year}-06-30`);
const finishyear = new Date(`${year}-12-31`);
const period = Date.now() < midyear.getTime() ? 1 : 2;
const defaultTime = {
  $gte: period === 1 ? startyear : midyear,
  $lte: period === 1 ? midyear : finishyear,
};

export default {
  components: {
    attemptFilter,
    resultsMutate,
    resultsGraph,
    resultsTable,
  },
  data() {
    return {
      services: [
        'flags',
        'locations',
        'procedures',
        'steps',
        'units',
        'users',
      ],
      query: JSON.parse(this.$route.query.f || '{}'),
      filters: [],
      results: [],
      displays: [
        { text: 'Graph', value: 'results-graph' },
        { text: 'Table', value: 'results-table' },
      ],
      display: this.$route.query.d || 'results-graph',
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('attempts', ['isFindPending', 'slowPercent']),
    perm() { return this.user.perm; },
  },
  async mounted() {
    await Promise.all(this.services.reverse().map(s => this.$store.dispatch(`${s}/find`)));
  },
  watch: {
    query: {
      handler() {
        const v = cloneDeep(this.query);
        delete v.stat;
        if (isEqual(v.time, defaultTime)) delete v.time;
        let f = JSON.stringify(v);
        if (!Object.keys(v).length) f = undefined;
        this.$router.push({ query: { ...this.$route.query, f } });
      },
      deep: true,
    },
    display() {
      switch (this.display) {
        case 'results-table':
          this.$router.push({
            query: { ...this.$route.query, d: this.display, c: undefined, m: undefined },
          });
          break;
        default: // results-graph
          this.$router.push({
            query: { ...this.$route.query, d: undefined, h: undefined },
          });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.results-toolbar >>> .v-select
  margin-left 1em
  width: min-content;
  min-width: 100px;
</style>
